import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import * as AireAcondicionadoActions from '../actions/aireAcondicionadoActions'
import { resetAireAcondicionado } from '../actions/aireAcondicionadoActions'
import { selectAireAcondicionado } from '../selectors/aireAcondicionadoSelectors'
import * as CestaActions from '../actions/cestaActions'
import { DataSteps, Steps } from '../../components/cesta/Steps'
import { navigate } from 'gatsby'
import { Vehicle } from '../../types/Vehiculo'
import * as CitaPreviaActions from '../actions/citaPreviaActions'
import { setSelectedService, setUserData } from '../actions/citaPreviaActions'
import route from '../../utils/route'
import {
  AreaPrivadaCitaPreviaEnum,
  areaPrivadaCitaSteps,
} from '../../components/CitaPrevia/CitaPreviaSteps'
import { selectUserInfo } from '../selectors/userSelectors'
import {
  AIRE_ACONDICIONADO_1234YF_ID,
  AIRE_ACONDICIONADO_ID,
  AireAcondicionadoState,
} from '../reducers/aireAcondicionadoReducer'
import { Device } from '../../types/Device'

const citaPreviaCompraAc2 = {
  service: 'cli',
  vehicle: 'Coche',
  nombre_es: 'Recarga de Gas Homologado R1234-YF',
  nombre_ca: 'Recàrrega de Gas Homologat  R1234-YF',
  nombre_pt: null,
  more_info_es: null,
  more_info_ca: null,
  more_info_pt: null,
}

const citaPreviaCompraAc = {
  service: 'cli',
  vehicle: 'Coche',
  nombre_es: 'Recarga de Gas Homologado R134A',
  nombre_ca: 'Recarrega de Gas Homologat R134A',
  nombre_pt: null,
  more_info_es: null,
  more_info_ca: null,
  more_info_pt: null,
}

function* addAireAcondicionadoCesta(
  id: string,
  vehicle: Vehicle,
  postCode: string
) {
  try {
    yield put(CestaActions.setCodigoPostalIntroducido(postCode))
    yield put(
      CestaActions.addProduct(
        {
          id,
          type: 'otros',
        },
        'ac',
        vehicle
      )
    )
    yield put(CestaActions.setStep(Steps.TU_SOLICITUD))
    yield navigate(DataSteps[Steps.TU_SOLICITUD].route)
    yield put(AireAcondicionadoActions.resetAireAcondicionado())
  } catch (err) {
    yield put(AireAcondicionadoActions.findAireAcondicionadoFailed(err.message))
  }
}

function* goToCitaPrevia(service, vehicle: Vehicle, device: Device) {
  const state = yield select()
  const userInfo = yield selectUserInfo(state)
  const url = route('aire-acondicionado.asistente.index')

  yield put(CitaPreviaActions.setSelectedService(service, url))
  yield put(
    setUserData({
      email: userInfo.email,
      name: userInfo.userName,
      phone: userInfo.phone,
      comment: '',
      device,
      marca: vehicle.marca,
      matricula: vehicle.cod_matricula,
      modelo: vehicle.modelo,
      origin: url,
    })
  )
  yield put(
    CitaPreviaActions.setCitaPreviaStep(
      AreaPrivadaCitaPreviaEnum.SELECCION_TALLER
    )
  )

  yield navigate(
    areaPrivadaCitaSteps[AreaPrivadaCitaPreviaEnum.SELECCION_TALLER].route
  )
  yield put(resetAireAcondicionado())
}

function* findAireAcondicionado() {
  const state = yield select()
  const acState: AireAcondicionadoState = yield selectAireAcondicionado(state)
  
  const { vehicle, postCode, device } = acState
  try {
    const shouldGoToCita = vehicle.ano_fabric === 0
    const isModernVehicle = vehicle.ano_fabric >= 2018
    const isAmbiguosVehicle = vehicle.ano_fabric >= 2013 && vehicle.ano_fabric <= 2017

    const aireId = isModernVehicle ? AIRE_ACONDICIONADO_1234YF_ID
                                   : isAmbiguosVehicle ? AIRE_ACONDICIONADO_ID : AIRE_ACONDICIONADO_ID

    const selectedService = isModernVehicle ? citaPreviaCompraAc2 
                          : isAmbiguosVehicle ? citaPreviaCompraAc2 : citaPreviaCompraAc

    if (shouldGoToCita) {
      yield call(goToCitaPrevia, selectedService, vehicle, device)
    } else {
      yield put(setSelectedService(selectedService))
      yield call(addAireAcondicionadoCesta, aireId, vehicle, postCode)
    } 
  } catch (err) {
    yield put(AireAcondicionadoActions.findAireAcondicionadoFailed(err.message))
  }
}

function* sagas() {
  return all([
    yield takeLatest(
      AireAcondicionadoActions.AIRE_ACONDICIONADO_FIND,
      findAireAcondicionado
    ),
  ])
}

export default sagas
